var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4"},[_c('div',{staticClass:"text-subtitle-2"},[_vm._v("\n    "+_vm._s(_vm.label)+":\n  ")]),_vm._v(" "),_c('div',{staticClass:"text-subtitle-1 font-weight-medium"},[(_vm.date)?[_vm._v("\n      "+_vm._s(_vm._f("datetime")(_vm.date,'YYYY-MM-DD h:mm a'))+"\n    ")]:[_vm._v("\n      N/A\n    ")]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }